export default __webpack_public_path__ + "static/media/carbg.ce8ce6f2.jpg";